import React, { useContext, useMemo } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import layoutStyles from '../styles/layout.module.css';
import styles from './AdminShell.module.css';
import { UserContext } from '../App';
import { hasAdminAccess, normalizeAdminGroups } from '../utils/admin';
import { getVisibleAdminPages } from './adminRegistry';

export default function AdminShell() {
  const appUser = useContext(UserContext);
  const navigate = useNavigate();
  const adminGroups = normalizeAdminGroups(appUser?.adminGroups);
  const hasAnyAdminAccess = hasAdminAccess(appUser, null);
  const pages = useMemo(() => getVisibleAdminPages(adminGroups), [adminGroups]);

  return (
    <div className={layoutStyles.detailPage}>
      <TopBar variant="back" backLabel="Back" onBack={() => (window.history.length > 2 ? navigate(-1) : navigate('/home'))} rightActionLabel="Home" onRightAction={() => navigate('/home')} />
      <div className={`${layoutStyles.detailMain} ${styles.pageShell}`.trim()}>
              <header className={styles.header}>
                <span className={styles.eyebrow}>Internal</span>
                <h1>Admin</h1>
                <p>
                  This is the new admin shell. Pages can be registered here and shown based on
                  `users/{'{uid}'}.adminGroups`.
                </p>
              </header>

              <section className={styles.card}>
                <h2>Access</h2>
                <div className={styles.metaGrid}>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Email</span>
                    <span className={styles.metaValue}>{appUser?.email || '—'}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>User ID</span>
                    <span className={styles.metaValue}>{appUser?.id || '—'}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Admin Groups</span>
                    <span className={styles.metaValue}>{adminGroups.length ? adminGroups.join(', ') : 'none'}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Access Status</span>
                    <span className={styles.metaValue}>{hasAnyAdminAccess ? 'Granted' : 'Denied'}</span>
                  </div>
                </div>
              </section>

              {!hasAnyAdminAccess ? (
                <section className={styles.card}>
                  <h2>Access Denied</h2>
                  <p className={styles.copy}>
                    Add at least one value to `adminGroups` on this user document to unlock the admin workspace.
                  </p>
                </section>
              ) : (
                <section className={styles.card}>
                  <h2>Registered Pages</h2>
                  {pages.length ? (
                    <div className={styles.registryList}>
                      {pages.map((page) => (
                        <button key={page.key} type="button" className={styles.registryCard} onClick={() => navigate(page.path || '/admin')}>
                          <div className={styles.registryCopy}>
                            <strong>{page.label}</strong>
                            <p>{page.description || 'No description.'}</p>
                          </div>
                          <FiArrowRight className={styles.registryArrow} />
                        </button>
                      ))}
                    </div>
                  ) : (
                    <div className={styles.emptyState}>
                      <strong>No admin tools installed yet.</strong>
                      <p>The new admin layer is live, but no pages are registered yet.</p>
                    </div>
                  )}
                </section>
              )}
      </div>
    </div>
  );
}
